<div [ngClass]="{ 'blurred': isShowTutorial }" class="container">
    <!-- Header -->
    <div class="header">
        <div class="header-left">
            <div class="logo-section">
                <img src="assets/img/phoenix-1.png" alt="Phoenix" class="header-logo" />
                <div class="logo-text">
                    <span class="logo-title">Phoenix</span>
                    <span class="logo-subtitle">Enhancing Silver Value</span>
                </div>
            </div>
        </div>
        <div class="header-right">
            
        </div>
        <div class="header-right">
            <h1 class="assessment-title">
                <span class="desktop-only">Análisis Del Presente - </span>Sección {{currentQuestionIndex + 1}} De {{questions.length}}
            </h1>
            <div class="progress-indicator">
                <div class="progress-bar-mini">
                    <div class="progress-fill" [style.width]="(currentQuestionIndex + 1) / questions.length * 100 + '%'"></div>
                </div>
            </div>
            <button class="exit-button">Salir</button>
        </div>
    </div>

    <!-- Step Navigation Bar -->
    <div class="step-navigation" #progressBarEspaciado>
        <div class="step-item active">
            <div class="step-header">
                <div class="step-icon">1</div>
                <div class="step-progress-bar">
                    <div class="step-progress-fill" [style.width]="(currentQuestionIndex + 1) / questions.length * 100 + '%'" ></div>
                </div>
            </div>
            <div class="step-footer-active">
                <span class="step-text-active">Análisis presente</span>
                <span class="step-status-active">En progreso</span>
            </div>
        </div>
        <div class="step-item">
            <div class="step-header">
                <div class="step-icon">2</div>
                <div class="step-progress-bar">
                    <div class="step-progress-fill" style="width: 0%"></div>
                </div>
            </div>
            <div class="step-info-container">
                <span class="step-text-inline">Análisis futuro</span>
                <span class="step-status-inline">Pendiente</span>
            </div>
        </div>
        <div class="step-item">
            <div class="step-header">
                <div class="step-icon">3</div>
                <div class="step-progress-bar">
                    <div class="step-progress-fill" style="width: 0%"></div>
                </div>
            </div>
            <div class="step-info-container">
                <span class="step-text-inline">Diagnostico</span>
                <span class="step-status-inline">Pendiente</span>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
        <!-- Left Panel - Questions and Slider -->
        <div class="left-panel">
            <div class="question-section">
                <h2 class="section-title">Análisis del presente - {{ questions[currentQuestionIndex]?.dimension?.name }}</h2>
                <p class="instructions">Analiza todas las preguntas y desliza el cursor para responder con un puntaje del 1 al 10.</p>
                
                <div class="questions-list" #questionTextContainer>
                    <div class="question-item" *ngFor="let question of splitQuestions(questions[currentQuestionIndex]?.title); let i = index">
                        <span class="question-number">{{i + 1}}.</span>
                        <span class="question-text">{{ question }}</span>
                    </div>
                </div>

                <div class="rating-section" #calification>
                    <app-range [value]="currentValue" [index]="currentQuestionIndex"
                        (onChange)="changeRange($event)"></app-range>
                </div>

                <!-- Footer Navigation -->
                <div class="footer-navigation">
                    <button class="back-button" (click)="previous()" *ngIf="currentQuestionIndex > 0">
                        ← Atrás
                    </button>
                    <button class="next-button" (click)="next()" [disabled]="currentValue === 0">
                        {{ isLastQuestion() ? 'Finalizar →' : 'Siguiente →' }}
                    </button>
                </div>

    
            </div>

        </div>

        <!-- Right Panel - Polar Chart -->
        <div class="right-panel">
            <div class="chart-container" #contentChart>
                <app-polar-chart [data]="dataSeries"></app-polar-chart>
            </div>
        </div>
    </div>

   

    <div class="overlay" *ngIf="isShowTutorial"></div>
    <app-tutorial-dialog class="tutorial-dialog" *ngIf="isShowTutorial" [title]="tutorialTitle"
        [description]="tutorialDescription" [currentStep]="tutorialStep" [totalSteps]="tutorialSteps.length"
        [position]="dialogPosition" (continue)="nextStepTutorial()" (skip)="changeShowTutorial()"
        (reset)="resetTutorial()">
    </app-tutorial-dialog>
</div>